export const PARTNER_INVENTORY_ISSUE_LABELS = {
  missing_photos: "Missing photos",
  missing_price: "Missing price",
  missing_mileage: "Missing mileage",
  missing_description: "Missing title or description",
  missing_location: "Missing location",
  any: "Any data issue",
};

export const PARTNER_INVENTORY_ISSUE_FILTERS = [
  { value: "", label: "All listings" },
  { value: "any", label: "Any data issue" },
  { value: "missing_photos", label: PARTNER_INVENTORY_ISSUE_LABELS.missing_photos },
  { value: "missing_price", label: PARTNER_INVENTORY_ISSUE_LABELS.missing_price },
  { value: "missing_mileage", label: PARTNER_INVENTORY_ISSUE_LABELS.missing_mileage },
  { value: "missing_description", label: PARTNER_INVENTORY_ISSUE_LABELS.missing_description },
  { value: "missing_location", label: PARTNER_INVENTORY_ISSUE_LABELS.missing_location },
];

export const PARTNER_INVENTORY_ARCHIVED_STATUS_FILTERS = [
  { value: "", label: "Sold and archived" },
  { value: "sold", label: "Sold" },
  { value: "archived", label: "Archived" },
];

export const PARTNER_INVENTORY_LISTING_STATUS_LABELS = {
  sold: "Sold",
  archived: "Archived",
};

export function partnerInventoryListingStatusLabel(status) {
  return PARTNER_INVENTORY_LISTING_STATUS_LABELS[status] || status || "—";
}

export function partnerInventoryIssueLabel(issueKey) {
  return PARTNER_INVENTORY_ISSUE_LABELS[issueKey] || issueKey;
}
